// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_37q4dEv3","checkboxBox":"_1SEhOv6c","checkboxIcon":"_1Of4cTzH","fullWidth":"GDpELTfP","checkboxLabel":"_1lj_xdhA"};